export default class PaginationAPC {
    constructor(node) {
        this.BLOCK = node;
        if (!this.BLOCK) throw new Error('node is not passed to constructor');

        this.BTN = node.querySelector('.pagination-apc__show-more');
        this.PAGER = node.querySelector('.pagination-apc__pager');
        this.PAGER_ITEMS_COLLECTION = this.PAGER.querySelectorAll('.pagination-apc__pager-item');
        this.AJAX_PARAM = null;
    }

    /**
     * Inits instance
     */
    init() {
        this.BTN.addEventListener('click', this.handleBtnClick);
        this.PAGER.addEventListener('click', this.handlePagerClick);
    }

    /**
     *
     */
    destroy() {}

    /**
     * Handles button click
     */
    handleBtnClick = e => {
        e.preventDefault();
        let target = e.target;

        while (target !== this.BTN) {
            target = target.parentNode;
        }

        this.AJAX_PARAM = target.dataset.ajaxParam;
        this.createAndDispatchEvent('ajax-load-more-click');
    };

    /**
     * Handles pager click
     */
    handlePagerClick = e => {
        e.preventDefault();
        let target = e.target;

        if (target.closest('.pagination-apc__pager-item')) {
            while (!target.classList.contains('pagination-apc__pager-item')) {
                target = target.parentNode;
            }

            this.AJAX_PARAM = target.dataset.ajaxParam;
            this.createAndDispatchEvent('ajax-src-container-click');
        }
    };

    /**
     * Creates and dispatches custom event
     */
    createAndDispatchEvent(eventName) {
        let event = new CustomEvent(eventName, {
            bubbles: true,
            detail: {
                ajaxParam: this.AJAX_PARAM,
                scrollToTop: true,
            },
        });

        this.BLOCK.dispatchEvent(event);
        this.AJAX_PARAM = null;
    }
}
